import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        }).then((res) => {
            resolve(res.data)
        }).catch((err) => {
            console.log('连接错误请求失败', err)
            reject(err.data)
        })
    })
}

export function post(url, data) {
    return new Promise((resolve, reject) => {
        axios.post(url, data)
        .then((res) => {
            resolve(res.data)
        }).catch((err) => {
            console.log('连接错误请求失败', err)
            reject(err)
        })
    })
}